export default "__VITE_ASSET__DmjSwNSL__"